module.exports = __webpack_public_path__ + "media/images/tab-personal-info-8b8d40888a073839c35815848df0b37b.png";